import moment from 'moment';

const formatDateToMonthString = (date: string | undefined): string => {
  return moment(date).utc().format('MMMM');
};

export default formatDateToMonthString;
